import * as types from './types';
import { has } from 'lodash';

const INITIAL_STATE = {
  resetPasswordStep: null,
  resetPasswordLoading: false,
  resetPasswordSuccess: null,
  resetPasswordError: null,
};

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case types.LOGIN_RESET_PASSWORD_LOADING:
      return {
        ...state,
        resetPasswordLoading: payload,
      };
    case types.LOGIN_SET_RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        resetPasswordSuccess: payload,
        resetPasswordStep: null,
      };
    case types.LOGIN_RESET_PASSWORD_POST_ERROR:
      if (has(payload, 'response.data')) {
        const resetPasswordError = payload.response.data.Errors[0];

        return {
          ...state,
          resetPasswordError,
        };
      }

      return {
        ...state,
        resetPasswordError: {
          Title: 'Error',
          Message: 'An error occurred while resetting your password.',
        },
      };
    case types.LOGIN_SET_RESET_PASSWORD_CLEAR_ERROR:
      return {
        ...state,
        resetPasswordError: null,
      };
    case types.LOGIN_SET_RESET_PASSWORD_STEP:
      return {
        ...state,
        resetPasswordStep: payload,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/login/state/resetpassword/reducer.js